import React from "react";
import { MediaType } from "../../../api/mediaApi";
import SvgSelector from "../svgSelector/SvgSelector";
import hiveStackIMG from "../../images/icons/hivestack.jpg";

type MediaPreviewControlProps = {
    mediaType: MediaType,
    previewUrl: string,
    className?: string
}

const MediaPreviewControl = (props: MediaPreviewControlProps) => {
    let className = props.className ? props.className : "media-img";
    let preview: React.ReactElement | null = null;

    switch(props.mediaType) {
        case MediaType.Image:
        case MediaType.Video:
        case MediaType.Youtube:
        case MediaType.YoutubeLive:
            if(props.previewUrl) {
                preview = <img className={className} src={props.previewUrl} alt="" />;
            }
            break;
        case MediaType.VastUrl:
            preview = <SvgSelector title="url" />;
            break;
        case MediaType.WebPage:
            preview = <SvgSelector title="webview" />;
            break;
        case MediaType.HiveStack:
            preview = <img className={className} src={hiveStackIMG} alt="" />;
            break;
    }

    return preview;
}

export default MediaPreviewControl;
